export const PermissionEnum = Object.freeze({
  boundariesEditRequest: "boundaries_edit_request",
  objectCreateMulti: "create_multi_object",
});
